import { GlobalStyles } from '@mui/material';
import { useTour } from '@reactour/tour';

// While a tour is open, raise the MUI POPPERS that portal to <body> —
// Autocomplete dropdowns and date/time picker calendars — above reactour's mask
// (z-index 99999) and popover (100000). By default they sit at ~1300, so they
// render BEHIND the dim overlay: visible-but-greyed and, worse, unclickable (the
// mask's click-catcher is stacked on top). Steps whose field opens such a popup
// (e.g. picking a state/province or a validity date) can't work until the popup
// is brought forward. Scoped to the tour: this only mounts while reactour reports
// the tour open, so normal app z-index ordering is untouched.
//
// NB: only Poppers (no backdrop) are raised — deliberately NOT Menu/Popover
// (`.MuiPopover-root`). Those are MODALS with a full-screen backdrop; raising the
// whole modal above the reactour chrome puts its backdrop over the popover, so
// clicking the popover's Next (or anywhere outside the menu) hits the backdrop and
// dismisses the menu instead. Menu-anchored steps (e.g. the Home tour's profile
// dropdown) show the menu through the spotlight hole at its normal z-index instead.
const popupLayerStyles = (
	<GlobalStyles
		styles={{
			'.MuiAutocomplete-popper, .MuiPickersPopper-root': {
				zIndex: '100001 !important',
			},
		}}
	/>
);

const TourPopupLayer = () => {
	const { isOpen } = useTour();
	return isOpen ? popupLayerStyles : null;
};

export default TourPopupLayer;
